import Table from 'react-bootstrap/Table';
import { Container, Card, Row } from 'react-bootstrap';

import { createClaimsTable } from '../utils/claimUtils';

import '../styles/App.css';

export const IdTokenData = (props) => {
    return (
        <div className="homepage">            
            <h2>Purpose:</h2>
            <p>
                Our application serves a crucial role in supporting employees with their timesheet management tasks to facilitate their entries.
            </p>

            <h2>How It Works:</h2>
            <ol>
                <li><strong>Integration with Harvest:</strong> The application retrieves the projects codes and their tasks assigned to you and allows you to create time entries for that particular task over the course of several weeks.</li>
                <li><strong>Stay tuned:</strong> We're building new functionalities to make your life easier.</li>

            </ol>
        </div>
    );
};

export const ProfileData = (props) => {
    const tableRows = Object.entries(props.graphData).map((entry, index) => {
        return (
            <tr key={index}>
                <td>
                    <b>{entry[0]} </b>
                </td>
                <td>{entry[1]}</td>
            </tr>
        );
    });
    return (
        <>
            <div className="data-area-div">
                <p>
                    Acquired an <strong>Access Token </strong>for MS Graph with scopes:
                    {props.response.scopes.map((scope, index) => (
                        <mark key={scope}>{scope}</mark>
                    ))}
                </p>

                <p>
                    Calling <strong>Microsoft Graph API</strong>...
                </p>
                <ul>
                    <li>
                        <strong>resource:</strong> <mark>User</mark> object
                    </li>
                    <li>
                        <strong>endpoint:</strong> <mark>https://graph.microsoft.com/v1.0/me</mark>
                    </li>
                    <li>
                        <strong>scope:</strong>
                        <mark>User.Read</mark>
                    </li>
                </ul>
                <p>
                    Contents of the <strong>response</strong> is below:
                </p>
            </div>
            <div className="data-area-div">
                <Table responsive striped bordered hover>
                    <thead></thead>
                    <tbody>{tableRows}</tbody>
                </Table>
            </div>
        </>
    );
};

export const ContactsData = (props) => {
    return (
        <Container>
            <Row>
                <div className="data-area-div">
                    <p>
                        Acquired an <strong>Access Token </strong>for MS Graph with scopes:
                        {props.response.scopes.map((scope, index) => (
                            <mark key={scope}>{scope}</mark>
                        ))}
                    </p>

                    <p>
                        Calling <strong>Microsoft Graph API</strong>...
                    </p>
                    <ul>
                        <li>
                            <strong>resource:</strong>
                            <mark>User</mark> object
                        </li>
                        <li>
                            <strong>endpoint:</strong> <mark>https://graph.microsoft.com/v1.0/me/contacts</mark>
                        </li>
                        <li>
                            <strong>scope:</strong>
                            <mark>Contacts.Read</mark>
                        </li>
                    </ul>
                    <p>
                        Contents of the <strong>response</strong> is below:
                    </p>
                </div>
            </Row>
            <Row className="d-flex flex-row">
                {!props.graphContacts.value  || props.graphContacts.value.length === 0 ? (
                    <p className="text-center">You have 0 contacts</p>
                ) : (
                    props.graphContacts.value.map((contact) => (
                        <Card className="card" key={contact.id}>
                            <Card.Body>
                                <Card.Title>{contact.displayName}</Card.Title>
                                <Card.Text>{contact.personalNotes}</Card.Text>
                            </Card.Body>
                        </Card>
                    ))
                )}
            </Row>
        </Container>
    );
};
